var exports = {
  "ZH": "GuildBadge.module__badgeWrapper___LVUzbz",
  "qS": "GuildBadge.module__badge___LVUzbz",
  "eT": "GuildBadge.module__badgeOnLightSurface___LVUzbz",
  "YW": "GuildBadge.module__badgeBanner___LVUzbz",
  "e$": "GuildBadge.module__badgeBannerDark___LVUzbz",
};

module.exports = exports;
